// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5255":"css/admin-app.7085","8765":"css/app.7085"}[chunkId] + ".css";
};